import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Modal, Spinner } from 'react-bootstrap';

import DropZone from 'components/shared/Dropzone';

const MANUFACTURER_LOGO_FOLDER = 'manufacturer_logo';

function LogoUpdateModal({ product, onHide, update, loading }) {
  const [uploadedLogoUrl, setUploadedLogoUrl] = useState([]);

  return (
    <Modal show={true} onHide={onHide} size="lg" className="px-6" centered>
      <Modal.Header closeButton>
        <div className="d-flex flex-column">
          <Modal.Title className="mont">
            <h2 className="font-weight-bold">Set Logo</h2>
          </Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div>
          <DropZone
            text="Drag and drop the logo image here, or click to select the image"
            onUploadSuccess={newUrls => setUploadedLogoUrl(newUrls)}
            fileUrls={uploadedLogoUrl}
            isImage={true}
            isPublic={true}
            filePath={MANUFACTURER_LOGO_FOLDER}
          />
          <div className="mt-3 d-flex justify-content-center align-items-center">
            <Button
              className="mr-2"
              disabled={uploadedLogoUrl?.length !== 1 || loading}
              variant="primary"
              onClick={() =>
                update({
                  id: product.id,
                  logo_url: uploadedLogoUrl[0],
                }).then(() => {
                  setUploadedLogoUrl([]);
                  onHide();
                })
              }
            >
              {loading ? <Spinner animation="border" role="status" size="sm" /> : 'Link Logo'}
            </Button>
            <Button variant="outline-primary" onClick={() => setUploadedLogoUrl([])}>
              Clear Images
            </Button>
          </div>
          <p className="small text-muted">* Upload just one image to make it the Logo</p>
        </div>
      </Modal.Body>
    </Modal>
  );
}

LogoUpdateModal.propTypes = {
  product: PropTypes.object,
  onHide: PropTypes.func,
  update: PropTypes.func,
  loading: PropTypes.bool,
};

export default LogoUpdateModal;
